function showEllipsis(width, value) {
  return String(value).length * 8 > width;
}

export { showEllipsis };
//# sourceMappingURL=showEllipsis.js.map
